import { FadeIn } from "./FadeIn";

const COVER_IMAGE =
  "https://customer-assets.emergentagent.com/job_cinematic-nocturne/artifacts/vgxor29t_GENESIS.jpg";

export const LatestRelease = () => {
  return (
    <section
      id="release"
      data-testid="release-section"
      className="relative py-32 md:py-48 px-6 sm:px-10 md:px-16"
    >
      <div className="max-w-7xl mx-auto">
        <FadeIn>
          <div className="flex items-center gap-4 mb-16 md:mb-24">
            <span className="kv-overline text-[#6b6b6b]">N° 01</span>
            <span className="h-px flex-1 bg-[#1a1a1a]" />
            <span className="kv-overline text-[#a3a3a3]">Featured Work</span>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-center">
          {/* Cover art */}
          <FadeIn className="md:col-span-6 lg:col-span-5" duration={2.2}>
            <div
              data-testid="release-cover"
              className="relative aspect-square w-full overflow-hidden bg-[#0c0c0c]"
            >
              <img
                src={COVER_IMAGE}
                alt="Cover art for the latest release: an abstract silver disc on a dark field."
                className="w-full h-full object-cover"
                style={{
                  filter: "grayscale(85%) contrast(0.95) brightness(0.85)",
                }}
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/5" />
            </div>
          </FadeIn>

          {/* Release details */}
          <FadeIn
            className="md:col-span-6 lg:col-span-7"
            duration={2.2}
            delay={0.2}
          >
            <p className="kv-overline text-[#a3a3a3] mb-6">
              Released · 2026
            </p>
            <h2
              data-testid="release-title"
              className="font-serif-display text-[#f2f0e9] text-4xl sm:text-5xl md:text-6xl leading-[1.02] mb-8 italic"
            >
              Genesis
            </h2>

            <div className="max-w-md space-y-5 text-[#a3a3a3] text-base leading-relaxed font-light">
              <p>
                A study in resonance and quiet restraint.
              </p>
              <p className="text-[#6b6b6b] text-sm">
                One minute seventeen seconds.
              </p>
            </div>

            {/* Tracklist preview */}
            <div className="mt-12 border-t border-[#1a1a1a]">
              {[
                ["I.", "Genesis"],
              ].map(([num, title]) => (
                <div
                  key={num}
                  className="grid grid-cols-12 gap-4 py-3 border-b border-[#141414] items-center"
                >
                  <span className="col-span-2 font-mono-archive text-xs text-[#6b6b6b]">
                    {num}
                  </span>
                  <span className="col-span-10 text-[#a3a3a3] text-sm tracking-wide font-light">
                    {title}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-4">
              <a
                href="https://open.spotify.com/track/6aZiFZfJHWGPvSRnZtV2ae?si=912a3f72cff9473e"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="release-listen-button"
                className="kv-button"
              >
                Listen
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default LatestRelease;
